import QuestionViewVerbal from "./QuestionViewVerbal";
import QuestionModel from "../../maths/QuestionModel";

export default class QuestionViewVisual extends QuestionViewVerbal {
    constructor(question) {
        super(question);

        if(question.hasOwnProperty('useBG')){
            if(question.useBG){
                let image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 0, 20, 0, 20);
                image.position.set(0, 340);
                image.width = 300;
                image.height = 250;
                image.pivot.set(image.width * 0.5, image.height * 0.5);
                this.addChild(image);
            }
        }

        this._display = new PIXI.Sprite(question.answer.texture);
        this._display.position.set(0, 340);
        this._display.anchor.set(0.5);
        this.addChild(this._display);
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        if (templates && templates.length > 0)
            templates = templates.slice().filter(x => this.filterTemplate(x));

        if (!templates || !templates.length) return "ERROR: NO TEMPLATE FOUND";

        this._template = P3.utils.selectRandom(templates);
        const words = data.words;

        let text = this._template ? this._template.text : "";
        if (this._template) {
            const names = this.generateWords(this._template.text, words.names, /\[NAME([0-9])?]/g);
            for (const i in names) {
                if (names.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), names[i]);
                }
            }

            const items = this.generateWords(this._template.text, words.items, /\[ITEM([0-9])?]/g);
            for (const i in items) {
                if (items.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), items[i]);
                }
            }

            const defenceitem = this.generateWords(this._template.text, words.defenceitem, /\[DEFENCE([0-9])?]/g);
            for (const i in defenceitem) {
                if (defenceitem.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), defenceitem[i]);
                }
            }

            const currency = this.generateWords(this._template.text, words.currency, /\[CURRENCY([0-9])?]/g);
            for (const i in currency) {
                if (currency.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), currency[i]);
                }
            }

            const itemPairs = this.generateWords(this._template.text, words.item_pairs, /\[ITEM_PAIR([0-9])?]/g);
            for (const i in itemPairs) {
                if (itemPairs.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i)), itemPairs[i][0]);//replace first instance
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), itemPairs[i][1]);//replace the rest
                }
            }

            const enemies = this.generateWords(this._template.text, words.enemies, /\[ENEMY([0-9])?]/g);
            for (const i in enemies) {
                if (enemies.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), enemies[i]);
                }
            }

            const locations = this.generateWords(this._template.text, words.locations, /\[LOCATION([0-9])?]/g);
            for (const i in locations) {
                if (locations.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), locations[i]);
                }
            }

            const values = this.generateValues(this._template.text, /\[VALUE([0-9])?]/g);
            for (const i in values) {
                if (values.hasOwnProperty(i)) {
                    if(this._template.hasOwnProperty('value'))
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), this._question.answer.value);
                    else
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
                }
            }

            const rands = this._template.text.match(/\[RANDINRANGE?]/g);
            if(rands){
                let valArr = [];
                for(let i = this._question.range.min; i <= this._question.range.max; i++){
                    let addToArr = true;
                    for(let j in values){
                        if(values[j] === i) addToArr = false;
                    }
                    if(addToArr) valArr.push(i);
                }
                const randVal = valArr[P3.math.randomInt(0, valArr.length-1)];
                for (const i in rands) {
                    text = text.replace(new RegExp(P3.utils.escape('[RANDINRANGE]'), "g"), randVal);
                }
            }

            const gems = text.match(/\[GEM([0-9])?]/g);
            if (gems)
                text = text.replace(gems, P3.utils.selectRandom(words.gems));

            const match = text.match(/\. [a-z]/g);
            if (match) {
                for (let i = 0; i < match.length; ++i) {
                    const s = match[i];
                    text = text.replace(new RegExp(P3.utils.escape(s), "g"), s.toUpperCase());
                }
            }

        }
        return text;
    }

    filterTemplate(x) {
        return true;
    }

    get display() {
        return this._display;
    }
}